import React, { useState } from 'react';
import {
  ChatChannelFilter,
  ChatMessageChannel,
  ChatSurface,
  chatChannelFilters,
  chatChannelLabels,
  chatTextColor,
  isChatChannel,
} from './chatColors';
import { cx } from './cx';
import Tabs from './Tabs';

export interface ChatMessage {
  id: string;
  channel: ChatMessageChannel;
  text: string;
  author?: string;
}

interface ChatBoxProps {
  messages: ChatMessage[];
  channel: ChatChannelFilter;
  onChannelChange: (channel: ChatChannelFilter) => void;
  onSend: (text: string) => void;
  surface?: ChatSurface;
  className?: string;
}

function lineText(message: ChatMessage): string {
  if (message.author) return `${message.author}: ${message.text}`;
  return message.text;
}

const ChatBox: React.FC<ChatBoxProps> = ({
  messages,
  channel,
  onChannelChange,
  onSend,
  surface = 'transparent',
  className,
}) => {
  const [draft, setDraft] = useState('');
  const visible = messages.filter((message) => channel === 'all' || message.channel === channel);

  return (
    <div className={cx('osrs-chat', surface === 'opaque' ? 'osrs-chat--opaque' : 'osrs-chat--transparent', className)}>
      <div className="osrs-chat__log">
        {visible.map((message) => (
          <p
            key={message.id}
            className="osrs-chat__line"
            style={{ color: chatTextColor(message.channel, surface) }}
          >
            {lineText(message)}
          </p>
        ))}
      </div>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          const text = draft.trim();
          if (!text) return;
          onSend(text);
          setDraft('');
        }}
      >
        <input
          className="osrs-chat__input"
          aria-label="Chat message"
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
        />
      </form>
      <Tabs
        label="Chat channels"
        value={channel}
        onChange={(id) => {
          if (isChatChannel(id)) onChannelChange(id);
        }}
        tabs={chatChannelFilters.map((id) => ({ id, label: chatChannelLabels[id] }))}
      />
    </div>
  );
};

export default ChatBox;
